module.exports = __webpack_public_path__ + "static/media/move.d05d95bd.svg";